export enum SpecialDayType {
  FATHER_DAY = 'FATHER_DAY',
  MOTHER_DAY = 'MOTHER_DAY',
}

export const SPECIAL_DAY_TYPE_LABELS = {
  [SpecialDayType.FATHER_DAY]: '父の日',
  [SpecialDayType.MOTHER_DAY]: '母の日',
} as const;
